import QuestionsModal from "PFApp/components/questions_modal";
import questionsModalCss from "PFApp/components/questions_modal/questions_modal.module.scss";
import useQuestionsModal from "PFApp/components/questions_modal/use_questions_modal";
import { Icon } from "PFComponents/icon";
import Modal from "PFComponents/modal/modal";
import { Typography } from "PFComponents/typography";
import { ActivitiesCollection } from "PFCore/hooks/queries/activities/query_keys";
import { useActivitiesInvalidate } from "PFCore/hooks/queries/activities/use_activities_invalidate";
import { MatchedActivity } from "PFTypes";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { MarketplaceButton, MarketplaceDangerButton } from "../../../../../components";
import css from "./interested_button.module.scss";

export const InterestedButton = ({ role }: { role: MatchedActivity["activity"] }) => {
  const [isMouseOver, setIsMouseOver] = useState(false);
  const { t } = useTranslation(["marketplace", "translation"]);
  const { invalidateByCollection } = useActivitiesInvalidate();

  const { questionModalProps, isQuestionsModalOpened, handleInterestButtonClick, closeQuestionsModal } =
    useQuestionsModal();

  const isInterested = !!role.interest_id;
  const interestedCount = role.statistics.interests_count;

  const handleShowInterest = useCallback(
    () =>
      handleInterestButtonClick(role.interest_id, role, () => {
        invalidateByCollection(ActivitiesCollection.MarketplaceActivity, role.id);
        invalidateByCollection(ActivitiesCollection.MatchingActivities);
        invalidateByCollection(ActivitiesCollection.Interested);
        invalidateByCollection(ActivitiesCollection.Saved);
        invalidateByCollection(ActivitiesCollection.Shared);
      }),
    [handleInterestButtonClick, invalidateByCollection, role]
  );

  const commonProps = {
    onClick: handleShowInterest,
    onMouseEnter: () => setIsMouseOver(true),
    onMouseLeave: () => setIsMouseOver(false)
  };

  return (
    <div className={css.container}>
      {isInterested && isMouseOver && (
        <MarketplaceDangerButton displayHover={false} className={css.removeInterestButton} {...commonProps}>
          <>
            <Icon name="cross" size="xs" />
            {t("translation:remove")}
          </>
        </MarketplaceDangerButton>
      )}
      {isInterested && !isMouseOver && (
        <MarketplaceButton theme="success" {...commonProps}>
          {t("translation:interested")}
        </MarketplaceButton>
      )}
      {!isInterested && (
        <MarketplaceButton {...commonProps}>{t("translation:showInterest")}</MarketplaceButton>
      )}
      <Typography variant="labelRegular" noMargin>
        {t("marketplace:workOpportunities.roleDetails.interestedCount", { count: interestedCount })}
      </Typography>

      {isQuestionsModalOpened && (
        // @ts-ignore
        <Modal
          handleClose={() => closeQuestionsModal()}
          classes={{
            dialog: questionsModalCss.questionsModal
          }}
        >
          {/* handleClose prop is automatically injected to QuestionsModal */}
          {/* this prop allows to close Modal with animation */}
          {/* @ts-ignore */}
          <QuestionsModal {...questionModalProps} />
        </Modal>
      )}
    </div>
  );
};
